import React, { createContext, useState, useEffect, useContext } from 'react';
import { translations } from '../i18n/translations';

const AppContext = createContext();

const defaultData = {
  clients: [],
  settings: {
    apiLogin: '',
    apiPassword: '',
    language: 'en'
  }
};

export const AppProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('kw_auth') === 'true';
  });

  const [data, setData] = useState(() => {
    const saved = localStorage.getItem('kw_master_data');
    return saved ? JSON.parse(saved) : defaultData;
  });

  useEffect(() => {
    localStorage.setItem('kw_master_data', JSON.stringify(data));
  }, [data]);

  const login = (code) => {
    if (code === '!@Adminweb11') {
      setIsAuthenticated(true);
      sessionStorage.setItem('kw_auth', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('kw_auth');
  };

  const t = (key) => {
    const lang = data.settings.language || 'en';
    return translations[lang][key] || key;
  };

  const updateSettings = (newSettings) => {
    setData(prev => ({ ...prev, settings: { ...prev.settings, ...newSettings } }));
  };

  return (
    <AppContext.Provider value={{
      isAuthenticated, login, logout,
      data, setData, t, updateSettings
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);